













































import { FilterOptions, Xhr, ScheduleItem } from './types';
import { defineComponent, PropType, ref } from '@vue/composition-api';

import OlbCheckbox from '../checkbox';
import OlbContentSlider from '../contentSlider';
import OlbImage from '../image';
import OlbButton from '../button';
import OlbScheduleListItem from './scheduleListItem.vue';
import OlbLoader from '../loader';
import OlbIcon from '../icon';
import { useFetch } from './useFetch';

export default defineComponent({
	components: {
		OlbCheckbox,
		OlbContentSlider,
		OlbImage,
		OlbButton,
		OlbScheduleListItem,
		OlbLoader,
		OlbIcon,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		loadMoreCaption: {
			type: String,
			required: true,
		},
		filter: { type: Object as PropType<FilterOptions>, required: true },
		xhr: { type: Object as PropType<Xhr>, required: true },
	},
	setup(props) {
		const preselectedIds = props.filter.options
			.filter((predicate) => predicate.checked)
			.map((predicate) => predicate.id);

		const preselectedTimeChooserItem = props.filter.timechooser.find((p) => p.selected);

		const selectedOptions = ref(preselectedIds);
		const selectedTime = ref(preselectedTimeChooserItem ? preselectedTimeChooserItem.value : undefined);
		const events = ref<ScheduleItem[]>([]);

		const { loadMore, hasMoreItems, isLoading, hasError, currentPage } = useFetch<ScheduleItem>(
			events,
			'entries',
			{
				url: props.xhr.url,
				method: props.xhr.method,
				params: () => ({
					...selectedOptions.value.reduce((acc, curr) => ({ ...acc, [curr]: 'on' }), {}),
					time: selectedTime.value,
					pagelength: props.xhr.itemsPerPage,
					_: Math.floor(Date.now() / 1000),
				}),
			},
			{
				dependencies: [selectedOptions, selectedTime],

				paging: {
					enabled: true,
					maxItemsProp: 'maxcount',
				},
			},
		);

		const onToggleCheckbox = (checked: boolean, checkboxId: string) => {
			checked
				? selectedOptions.value.push(checkboxId)
				: selectedOptions.value.splice(selectedOptions.value.indexOf(checkboxId), 1);
		};

		return {
			onToggleCheckbox,
			loadMore,
			currentPage,
			selectedOptions,
			selectedTime,
			isLoading,
			events,
			hasError,
			hasMoreItems,
		};
	},
});
